import React from 'react';
import BankersBlanketPopUpForm from './BankersBlanketPopUpForm';
import { IPolicyBankersDetails } from '../../../..';

interface IBankersBlanketPopUpProps {
  currencySymbol: string;
  data: IPolicyBankersDetails[];
  lovs: Record<string, Record<string, string>>;
  onClose: () => void;
  onSuccess: () => void;
}

const BankersBlanketPopUp: React.FC<IBankersBlanketPopUpProps> = ({
  currencySymbol,
  data,
  lovs,
  onClose,
  onSuccess,
}) => {
  return (
    <BankersBlanketPopUpForm
      currencySymbol={currencySymbol}
      data={data}
      lovs={lovs}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
};

export default BankersBlanketPopUp;
